import React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import product01 from "../../Assets/Product/KMRKRSKLNM1finalv3.png";
import product02 from "../../Assets/Product/STSA-000finalestsilo v1.png";
import product03 from "../../Assets/Product/Assemblycomplitesteptwo-wayfinalv2.png";
import product04 from "../../Assets/Product/1.SSReactorwithLimpetCoilAssemblyfinalv2.png";
import product05 from "../../Assets/Product/Mixer_Tankv3.png";
import product06 from "../../Assets/Product/PVfinalv2.png";
import product08 from "../../Assets/Product/IMG-9206.jpg";
import product09 from "../../Assets/Product/IMG-9210.jpg";
import product10 from "../../Assets/Product/IMG-9211.jpg";
import product11 from "../../Assets/Product/IMG_9435.png";
import product12 from "../../Assets/Product/IMG_9436.png";
import product13 from "../../Assets/Product/IMG_0531.JPG";
import product14 from "../../Assets/Product/IMG_2638.JPG";
import rightArrow from "../../Assets/Product/Frame.png";

import "./ProductsMainSection.css";

const html = (
  <>
    <p className="modal_title">Tank & Vessels</p>
    <p className="modal_text">
      Our tanks and vessels are built to serve a variety of industrial
      applications. Whether for storage, pressure containment, or mixing, we
      provide durable, high-quality equipment built to your exact
      specifications.
    </p>
    <p className="modal_semi_title">Storage Tanks</p>
    <ul className="modal_ul_list">
      <li>Capacity: 1 kL to 50 kL</li>
      <li>Geometry: Horizontal, Vertical</li>
      <li>Types: Single-walled, Double-walled</li>
      <li>Coating: Epoxy</li>
    </ul>
  </>
);

const ProductsMainSection = () => {
  let navigate = useNavigate();

  const ProductList = [
    {
      id: 1,
      title: "Environmental Equipment",
      image: product01,
      html: html,
    },
    { id: 2, title: "Silos", image: product02, html: html },
    { id: 3, title: "Heat Exchangers", image: product03, html: html },
    { id: 4, title: "Reactors", image: product04, html: html },
    { id: 5, title: "Custom Fabrication", image: product05, html: html },
    { id: 6, title: "Tanks & Vessels", image: product06, html: html },
  ];

  const OurGalleryList = [
    { id: 1, title: "Product-1", image: product08 },
    { id: 2, title: "Product-2", image: product09 },
    { id: 3, title: "Product-3", image: product10 },
    { id: 4, title: "Product-4", image: product11 },
    { id: 5, title: "Product-5", image: product12 },
    { id: 6, title: "Product-6", image: product13 },
    { id: 7, title: "Product-7", image: product14 },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,useCSS: true,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    autoplay: true,
  };

  return (
    <div className="products_main_section">
      {/* Products Section */}
      <section id="products" className="container">
        <div className="row">
          <h2 className="section_title">Our Expertise - Your Advantage:</h2>
          <div className="cover_products">
            {ProductList.map((item) => (
              <div key={item.id} className="products_container">
                <img src={item.image} height={300} alt="products" />
                <div className="mt-3 w-100">
                 <a href={`/products/${item.id}`} style={{textDecoration:'none',border:'none'}}>
                 <button 
                    onClick={() => {
                      navigate(`/products/${item.id}`);
                    }}
                    className="ct_btn_outline_primary w-100"
                  >
                    {item.title}
                    <img
                      src={rightArrow}
                      width={20}
                      height={20}
                      alt="right Arrow"
                      className="btn_rightArrow"
                    />
                  </button>
                  </a> 
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Gallery Section with React-Slick */}
      <section id="gallery" className="container container_gallery mt-5">
        <h2 className="section_title">Gallery</h2>
        <Slider {...sliderSettings}>
          {OurGalleryList.map((item) => (
            <div key={item.id} className="gallery_item">
              <img
                src={item.image}
                alt={item.title}
                className="gallery_image"
              />
            </div>
          ))}
        </Slider>
      </section>
    </div>
  );
};

export default ProductsMainSection;
